import { render, staticRenderFns } from "./ReviewsModal.vue?vue&type=template&id=1fa7ff96&scoped=true"
import script from "./ReviewsModal.vue?vue&type=script&lang=js"
export * from "./ReviewsModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewsModal.vue?vue&type=style&index=0&id=1fa7ff96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7ff96",
  null
  
)

export default component.exports